import KYCVerificationWidget from "./KYCVerificationWidget";

export default KYCVerificationWidget;

export * from "./KYCProfileForm/validationSchema";
export type { IKYCVerificationWidgetProps } from "./KYCVerificationWidget";
export * from "./modalStyles";
export * from "./types";
export * from "./useKycStatusModals";
